// Import external dependencies
import "jquery";
import "bootstrap";
import "whatwg-fetch";
import Promise from "promise-polyfill";
import objectFitPolyfill from "./utilities/objectFitPolyfill.min.js";
import initCarousels from "./utilities/carousels";
import selectric from "./utilities/jquery.selectric.js";
import initForms from "./utilities/forms";
import { waypoints } from "./utilities/waypoints";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "./utilities/body-scroll-lock.js";
import "picturefill";
import "lazysizes";
import RevealOnScroll from "./utilities/RevealOnScroll";
import "./utilities/header.js";
import "./utilities/modals.js";

// On document ready
$(document).ready(function() {
  initCarousels();
  initForms();
  new RevealOnScroll($(".reveal-item"), "99%");

  textAnimation(true);
  scrollDirection();
  checkNotificationBannerHeight();

  //Check Location Radio Buttons
  var pageLocation = $('body').data('location');
  $("input:radio[name='NexudusId']").each(function () {
    var radioTitle = $(this).attr("title");
    if (radioTitle.toLowerCase().indexOf(pageLocation) >= 0) {
      $(this).prop("checked", true);
    }
  });

  var hash= window.location.hash
if ( hash == '' || hash == '#' || hash == undefined ) return false;
      var target = $(hash);
      target = target.length ? target : $('[name=' + hash.slice(1) +']');
      if (target.length) {
        $('html,body').stop().animate({
          scrollTop: target.offset().top - 80 //offsets for fixed header
        }, 'linear');
      }
}); 

$( window ).resize(function() {
  checkNotificationBannerHeight();
  textAnimation(false);
});

$(window).on("load", function() {
  textAnimation(false);
  Waypoint.refreshAll();
  setTimeout(function(){  Waypoint.refreshAll(); }, 3000);
});

// Let the document know when the mouse is being used
document.body.addEventListener("mousedown", function() {
  document.body.classList.add("using-mouse");
});

// Re-enable focus styling when Tab is pressed
document.body.addEventListener("keydown", function(event) {
  if (event.keyCode === 9) {
    document.body.classList.remove("using-mouse");
  }
});

// Scroll direction
var lastScrolled = 0;
$(window).on("scroll", function() {
  scrollDirection();
});

// Inpage navigation
var waypointsDown = $('section').waypoint({
  element: $(this),
  handler: function(direction) {
    if (direction === "down") {
      var itemId = this.element.id;
      if(itemId != "") {
        $(".cb-in-page-nav li.active").removeClass("active");
        $(".cb-in-page-nav").find('li[data-section-id='+itemId+']').addClass("active");
      } else {
        $(".cb-in-page-nav li.active").removeClass("active");
      }
    }
  },
  offset: function() {
    return 110
  }
})

// Inpage navigation
var waypointsUp = $('section').waypoint({
  element: $(this),
  handler: function(direction) {
    if (direction === "up") {
      var itemId = this.element.id;
      if(itemId != "") {
        $(".cb-in-page-nav li.active").removeClass("active");
        $(".cb-in-page-nav").find('li[data-section-id='+itemId+']').addClass("active");
      } else {
        $(".cb-in-page-nav li.active").removeClass("active");
      }
    }
  },
  offset: function() {
    return -this.element.clientHeight + 110
  }
})

// Page scroll direction checker
function scrollDirection() {
  var justScrolled = window.pageYOffset || document.documentElement.scrollTop;
  if ((justScrolled > lastScrolled) && (justScrolled > 100)) {
    $("body").removeClass("scrolled-up");
    $("body").addClass("scrolled-down");
  } else {
    $("body").removeClass("scrolled-down");
    $("body").addClass("scrolled-up");
  }
  if (justScrolled > 100) {
    $("body").addClass("scrolled-enough");
  } else {
    $("body").removeClass("scrolled-enough");
  }
  // For mobile or negative scrolling
  lastScrolled = justScrolled <= 0 ? 0 : justScrolled;
}

// Inpage navigation
function scrollToAnchor(aid) {
  var aTag = $(aid);
  $("html,body").animate(
    {
      scrollTop: aTag.offset().top - 96
    },
    800
  );
}

$(".scroll-link").on("click", function(event) {
  event.preventDefault();
  var anchorID = $(this).attr("href");
  scrollToAnchor(anchorID);
  $(anchorID).find('button:first, a:first, input:first, select:first, textarea:first, [tabindex]:not([tabindex="-1"]):first').focus();
});

// CSS animation callback
function whichTransitionEvent() {
  var t,
    el = document.createElement("fakeelement");

  var transitions = {
    transition: "transitionend",
    OTransition: "oTransitionEnd",
    MozTransition: "transitionend",
    WebkitTransition: "webkitTransitionEnd"
  };

  for (t in transitions) {
    if (el.style[t] !== undefined) {
      return transitions[t];
    }
  }
}

function checkNotificationBannerHeight() {
  if($('.cb-notification-banner').length){
    if(jQuery(".cb-notification-banner").height() > 16) {
      jQuery("body").addClass("notification-banner--two-lines");
      jQuery("header.header").addClass("notification-banner--two-lines");
    } else {
      jQuery("body").removeClass("notification-banner--two-lines");
      jQuery("header.header").removeClass("notification-banner--two-lines");      
    }
  }
}

function textAnimation(appendSvg) {
  if($('.text-animation').length){
    var current_animation = 0;
    $('.text-animation').each(function () {
      if  ($(this).hasClass('squiggle--type-1')) {
        if(appendSvg) {
          var svg = `<svg class="text-animation-svg squiggle-svg--type-1 text-animation-${ current_animation }" preserveAspectRatio="none" viewBox="0 0 153 49" fill="none" xmlns="http://www.w3.org/2000/svg"><path  d="M94.6843 1C71.3794 5.04227 46.5308 6.85224 24.5508 16.3233C17.0382 19.5605 7.35727 23.0275 2.6753 30.3292C-4.33262 41.2582 12.4558 42.7496 19.6973 44.0577C44.8543 48.6022 71.561 48.9403 96.9378 46.4845C110.837 45.1394 125.829 42.4413 138.574 36.4308C141.196 35.1942 153.661 28.4369 152.407 24.2969C151.287 20.6012 144.459 18.3608 141.521 17.086C135.46 14.4568 113.562 8.60984 102.465 8.60984C65.6836 4.17077 69.1715 6.70738 25.732 6.70738" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
          $(this).closest('.c-wysiwyg').append(svg);
        }
        $('.text-animation-'+current_animation).css('top', ($(this).position().top - ($(this).height()*0.2)));
        $('.text-animation-'+current_animation).css('left', ($(this).position().left - ($(this).width()*0.06)));
        $('.text-animation-'+current_animation).width($(this).width() * 1.12 );
        $('.text-animation-'+current_animation).height($(this).height() * 1.3 );   
        current_animation = current_animation + 1;
      } else if($(this).hasClass('squiggle--type-2')) {
        if(appendSvg) {
          var svg = `<svg class="text-animation-svg squiggle-svg--type-2 text-animation-${ current_animation }" preserveAspectRatio="none" viewBox="0 0 163 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 15C4.24889 8.06926 10.2547 6.57391 17.2941 10.6612C19.3696 11.8663 19.3888 15.2349 21.1077 13.225C26.6131 6.78727 37.2409 3.46963 41.2153 13.1593C42.0972 15.3092 44.8302 11.655 46.1729 10.7927C49.8133 8.45457 54.4013 5.64177 59.0349 6.19092C63.2372 6.68896 64.2565 11.2565 66.9046 13.6195C67.7647 14.3869 78.4974 7.3877 80.3906 6.71683C84.1752 5.37577 86.5849 5.39251 89.127 8.62328C90.2853 10.0953 91.4357 11.6514 92.3165 13.2908C92.5558 13.736 92.3599 15.0904 92.7326 14.737C98.1339 9.61597 111.933 -3.78928 119.843 4.74465C122.419 7.52334 121.428 10.4573 125.356 8.42606C132.103 4.93645 140.536 2.75938 148.063 1.49055C153.265 0.613804 154.849 0.55464 157.978 4.38308C159.057 5.70299 160.433 8.34078 162 9.08345" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
          $(this).closest('.c-wysiwyg').append(svg);
        }
        $('.text-animation-'+current_animation).css('top', ($(this).position().top + ($(this).height() * 0.85) ));
        $('.text-animation-'+current_animation).css('left', ($(this).position().left));
        $('.text-animation-'+current_animation).width($(this).width());
        $('.text-animation-'+current_animation).height($(this).height() * 0.2 );   
        current_animation = current_animation + 1;
      } else if($(this).hasClass('squiggle--type-3')) {
          if(appendSvg) {
          var svg = `<svg class="text-animation-svg squiggle-svg--type-3 text-animation-${ current_animation }" preserveAspectRatio="none" viewBox="0 0 184 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 10C36.7964 9.40605 72.6032 9.62244 108.417 9.73762C119.889 9.77452 131.333 9.57066 142.8 9.57066C147.858 9.57066 132.826 8.82765 127.824 8.4973C95.7661 6.38012 63.578 4.45504 31.3333 2.97549C24.3905 2.65691 17.4243 2.30618 10.4588 2.09295C9.47665 2.06288 6.90828 2.28716 7.5233 1.94983C8.02671 1.67373 11.8376 1.74942 12.0624 1.74709C26.0229 1.60239 40.0612 1.85262 54.0018 2.12873C95.4625 -0.0665754 137.019 1.61675 178.542 1.61675C180.044 1.61675 181.73 1.77363 183 1.40208" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
          $(this).closest('.c-wysiwyg').append(svg);
        }
        $('.text-animation-'+current_animation).css('top', ($(this).position().top + ($(this).height() * 0.85) ));
        $('.text-animation-'+current_animation).css('left', ($(this).position().left));
        $('.text-animation-'+current_animation).width($(this).width());
        $('.text-animation-'+current_animation).height($(this).height() * 0.2 );    
        current_animation = current_animation + 1;
      } else if($(this).hasClass('squiggle--type-4')) {
        if(appendSvg) {
          var svg = `<svg class="text-animation-svg squiggle-svg--type-4 text-animation-${ current_animation }" preserveAspectRatio="none" viewBox="0 0 165 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 8.35397C2.9468 7.86167 4.72126 7.22157 6.41298 6.48821C7.72029 5.92149 7.18711 6.90696 7.30836 7.50171C7.40065 7.95435 7.58395 9.37429 8.81423 8.90678C11.7787 7.78028 14.4049 6.52703 17.6052 5.56685C22.9682 3.95781 18.8979 8.7238 22.2042 8.42307C25.1045 8.15927 28.2187 7.12318 30.9546 6.55731C31.7157 6.39988 37.8454 5.23803 37.8124 5.29044C37.3891 5.96119 37.0855 6.83538 38.8298 6.63793C42.1063 6.26706 45.2847 5.54875 48.4959 5.03707C48.7391 4.99831 52.1689 4.27113 52.871 4.66852C53.5257 5.03906 52.9661 6.54238 53.0338 7.04103C53.1623 7.98656   56.5224 6.83702 57.2055 6.69552C61.5888 5.78752 66.0784 5.02944 70.5141 4.20784C72.7087 3.80136 72.353 4.4633 72.7933 5.47471C73.1726 6.34605 73.7447 6.40186 75.1538 6.02753C79.9405 4.75591 84.6995 3.46174 89.5816 2.30753C92.2364 1.67991 91.7724 2.03915 91.8608 3.39013C91.9025 4.02712 91.8953 5.25188 93.1021 5.62443C94.161 5.9513 96.966 4.87605 97.6808 4.68004C101.922 3.51687 106.266 2.37678 110.725 1.50134C112.675 1.1184 111.693 3.8337 113.676 4.09267C115.752 4.36384 119.65 3.18966 121.571 2.83732C123.829 2.42327 126.056 1.96055 128.307 1.53589C128.751 1.45208 130.961 0.86382 131.603 1.02914C132.15 1.16963 132.556 2.68074 132.784 2.98704C133.3 3.68188 134.542 4.08886 135.877 3.9084C138.682 3.52929 141.479 2.92854 144.261 2.48029C146.453 2.12701 145.952 2.21636 146.642 3.17131C148.061 5.13479 154.416 3.38974 156.817 3.11372C159.837 2.76654 161.139 3.84802 164 4.20784" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
          $(this).closest('.c-wysiwyg').append(svg);
        }
        $('.text-animation-'+current_animation).css('top', ($(this).position().top + ($(this).height() * 0.85) ));
        $('.text-animation-'+current_animation).css('left', ($(this).position().left));
        $('.text-animation-'+current_animation).width($(this).width());
        $('.text-animation-'+current_animation).height($(this).height() * 0.2 );    
        current_animation = current_animation + 1;
      } else if($(this).hasClass('squiggle--type-5')) {
        if(appendSvg) {
          var svg = `<svg class="text-animation-svg squiggle-svg--type-5 text-animation-${ current_animation }" preserveAspectRatio="none" viewBox="0 0 188 43" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M53.5312 41.2413C67.255 41.0347 81.4616 40.0701 94.9444 38.7545C107.125 37.566 119.166 35.8892 131.151 34.2445C141.184 32.8678 152.097 31.6859 161.521 29.2709C168.616 27.4528 177.541 24.9386 179.992 21.1339C181.896 18.1799 176.124 13.1564 171.46 11.2309C160.177 6.57204 144.809 3.19972 130.678 2.21097C110.875 0.825317 90.2428 0.689848 70.3331 1.49443C57.5875 2.00951 44.9258 3.25299 32.5091 4.84531C21.3205 6.28013 17.3161 6.85714 6.51734 10.3037C-10.5852 17.9545 16.6512 25.7605 26.3259 28.8214C38.3517 32.6262 61.9307 36.322 75.3816 37.5743C96.91 39.5787 118.555 40.3921 140.381 40.6512C156.075 40.8376 171.481 40.7436 187 42" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
          $(this).closest('.c-wysiwyg').append(svg);
        }
        $('.text-animation-'+current_animation).css('top', ($(this).position().top));
        $('.text-animation-'+current_animation).css('left', ($(this).position().left - ($(this).width()*0.06)));
        $('.text-animation-'+current_animation).width($(this).width() * 1.12 );
        $('.text-animation-'+current_animation).height($(this).height() * 1.3 );   
        current_animation = current_animation + 1;
      }
     });
  }
}

// Jquery attribute plugin toggle
$.fn.toggleAttr = function(attr, attr1, attr2) {
  return this.each(function() {
    var self = $(this);
    if (self.attr(attr) == attr1)
      self.attr(attr, attr2);
    else
      self.attr(attr, attr1);
  });
};

// Accordion open/close logic
$(".cb-accordion--type-one").each(function(element) {
  var acc = $(".cb-accordion__item-heading");
  var i;
  
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      $(this).parent().toggleClass("active");
      $(this).find('button').toggleAttr('aria-expanded', 'false', 'true');
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
      var transitionEvent = whichTransitionEvent();
      var cb_accordion__item_content = $(this).next();
      if (!$(this).parent().hasClass('active')) {
        $(this).next().one(transitionEvent, function (e) {
          cb_accordion__item_content.find('.cb-accordion__item-content-text').removeClass('cb-accordion__item-content-text--show-visiblity');
          console.log('hide');
        });
      } else {
        cb_accordion__item_content.find('.cb-accordion__item-content-text').addClass('cb-accordion__item-content-text--show-visiblity');
        console.log('show');
      }
    });
  }
});


$('form .c-dropdown-selectric select').selectric({
  maxHeight: 300,
  arrowButtonMarkup: '<b class="button"></b>', //remove arrow icon which is messing up screenreader 'flow'
  // nativeOnMobile: false,
});

$('input.selectric-input').attr('aria-hidden','true');
$('.selectric').attr('aria-hidden','true');
$( ".selectric-hide-select.selectric-is-native select").attr("tabindex", "0");
$('input.selectric-input').attr("tabindex", "-1");

// Play and pause videos on click
$('video').click(function(){
  this.paused ? this.play() : this.pause();
  $("#video-controls").hide();
  return false;
});
